import React from 'react';

/**
 * BBA emblem + wordmark lockup, scaled down from the brand lockup design.
 * Used on the login and signup cards in place of the flat logo image.
 */
const BBALogoLockup = ({ className = '' }) => (
  <div className={`flex items-center justify-center gap-3.5 ${className}`}>
    <img src="/bba-emblem.svg" alt="BBA Emblem" className="w-28 h-28 object-contain" />
    <div className="flex flex-col items-center gap-1">
      <div
        className="whitespace-nowrap leading-none"
        style={{ fontFamily: "'Oswald', sans-serif", fontWeight: 700, fontSize: 22, letterSpacing: '0.02em', color: '#14110F' }}
      >
        BUILDERS BREAKTHROUGH
      </div>
      <div
        className="leading-none"
        style={{ fontFamily: "'Oswald', sans-serif", fontWeight: 500, fontSize: 15, letterSpacing: '0.06em', textIndent: '0.06em', color: '#14110F' }}
      >
        ADVISORS
      </div>
    </div>
  </div>
);

export default BBALogoLockup;
